export default {
  // Este componente usa etiquetas dinámicas desde props (channelName)
  // No hay cadenas estáticas traducibles
}
